import { useState, useEffect, RefObject } from 'react'

function useListenOutsideClick(elRef: RefObject<HTMLDivElement>) {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (!elRef.current?.contains(e.target as Node)) {
        setIsActive(false)
      }
    }

    if (isActive) {
      document.addEventListener('click', onClickOutside)
    }

    return () => {
      document.removeEventListener('click', onClickOutside)
    }
  }, [elRef, isActive])

  return [isActive, setIsActive] as const
}

export default useListenOutsideClick
